module.exports = __webpack_public_path__ + "static/img/5-3.37437908.png";